import { getHashObj } from "@/utils/utils";
import responsesCache from "@/vue/planning/state/responsesCache"
import getCacheKey from "../../logic/getCacheKey";

type PlanningState = { // this is used by the green thing
    packCode: string
    seAvailabilities: {[key: string]: any} | null
    quotePrices: {[key: string]: any} | null
    selectedPrestations: any
    selectedDates: any
    loading: boolean
    language: string
    cheapestPrestation: {[key: string]: any} | null
    productUnavailable: boolean
    participants: Array<number>
}

export default {
    refreshDataStoredOnWindow: (storeObj: any) => {
        const { state, getters } = storeObj

        const cacheKey = getCacheKey(state.packCode, state.dates.BeginDate, state.dates.EndDate, state.season, state.participants)
        const availResponse = responsesCache.value.getResponse("availabilities", cacheKey)
        const priceResponse = responsesCache.value.getResponse("prices", cacheKey)
        
        const newPlanningState: PlanningState = {
            packCode: state.packCode,
            seAvailabilities: availResponse ? availResponse : null,
            quotePrices: availResponse ? priceResponse : null,
            selectedPrestations: availResponse ? getters.selectedPrestations : null,
            selectedDates: state.dates,
            loading: state.loading,
            language: state.language,
            cheapestPrestation: availResponse ? getters.prestations[getters.cheapestPrestationIndex] : null,
            productUnavailable: availResponse ? state.productUnavailable : null,
            participants: state.participants,
        };

        window.planningState = newPlanningState;

        window.dispatchEvent(new Event("planningStateRefreshed"));
    },

    ensurePrestationsPreselected: (storeObj: any) => {
        const { state, getters, commit, dispatch } = storeObj

        const checkedNeedToPreselectPrestations = state.checkedNeedToPreselectPrestations;
        const liheData = state.liheData;
        const variants = getters.variants;

        if (checkedNeedToPreselectPrestations) return;

        // retrieve selection from last time visited page during same session
        const selectedPrestIds_fromPreviousActivity_JSONstring = window.sessionStorage.getItem(`selectedPrestIds-${liheData.id}`);

        if (selectedPrestIds_fromPreviousActivity_JSONstring) {
            // preselect from previous activity (stored in sessionStorage)
            const selectedPrestIds_fromPreviousActivity = JSON.parse(selectedPrestIds_fromPreviousActivity_JSONstring);
            dispatch("setSelectedPrestIds", selectedPrestIds_fromPreviousActivity);
        } else {
            // preselect from hash if no previous activity recorded
            const hash = window.location.hash.replace("#", "");
            const hashObj: {[key: string]: any} = getHashObj(hash);
            const prest_id_source = hashObj.prest_id_source;
            const variant = variants.find((item: any) => item.prestIdSource === prest_id_source);
            if (variant) {
                // if variant with this prest_id_source exists - select it
                const obj: {[key: string]: any} = {};
                obj[variant.id] = 1;
                obj["scrollToSummary"] = false; //- no longer need to scroll to summary if prest_id_source is in url on load
                dispatch("setSelectedPrestIds", obj);
            }
        }
        commit("setCheckedNeedToPreselectPrestations", true);
    },

    toggleTransport: (storeObj: any) => {
        const { state, commit } = storeObj

        const newBool = !state.transportCheckbox;
        commit("setTransport", newBool);
    },
};
